import { MenuItem } from '../../models';

/** holds items for leaderboards dropdown used in navbar */
export const LEADERBOARDS_LIST: MenuItem[] = [{ title: 'Leaderboards', link: '/leaderboards' }];
